// DCL-638: the one way to ask "are you sure?". Resolves true when the user
// confirms and false when they back out, so callers have no rejection to catch.
//
// options: title, message, warning (optional, shown as an alert), confirmText,
// cancelText. All of them render as text, so user data is safe to pass.
angular.module('dentalLinksServices')
.factory('ConfirmDialog', ['$uibModal', 'ModalHandler', function ($uibModal, ModalHandler) {
    return {
        open: function (options) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/confirm_dialog.html',
                controller: 'ConfirmDialogController',
                resolve: {
                    options: function () { return options; }
                }
            });
            ModalHandler.set(modalInstance);

            return modalInstance.result.then(function () {
                return true;
            }, function () {
                return false;
            });
        }
    };
}]);
